import _ from 'lodash'
import { name } from '../symbols'
import { named, withDependencies } from '@wix/thunderbolt-ioc'
import { CarmiInstance, EditorFeatureConfigSymbol, FeatureStateSymbol } from '@wix/thunderbolt-symbols'
import type { IFeatureState } from 'thunderbolt-feature-state'
import type { DSCarmi } from 'thunderbolt-ds-carmi-root'
import type { ActiveVariantsApiState, IActiveVariantsApi, TriggersAndReactionsEditorConfig } from '../types'
import { Catharsis, CatharsisSymbol } from '@wix/thunderbolt-catharsis'

export const ActiveVariantsApi = withDependencies(
	[named(FeatureStateSymbol, name), named(EditorFeatureConfigSymbol, name), CarmiInstance, CatharsisSymbol],
	(
		featureState: IFeatureState<ActiveVariantsApiState>,
		editorConfig: TriggersAndReactionsEditorConfig,
		{ variants: setter }: DSCarmi,
		catharsis: Catharsis
	): IActiveVariantsApi => {
		let currentPageActiveVariant = ''
		featureState.update(() => ({ compVariantMap: {} }))

		const updateState = (compId: string, variantId?: string, forceSet?: boolean) => {
			const compVariantMap = featureState.get().compVariantMap

			if (variantId) {
				compVariantMap[compId] = variantId
				if (forceSet || (compId === editorConfig.pageId && variantId !== currentPageActiveVariant)) {
					currentPageActiveVariant = variantId

					setter.setActiveVariant(variantId)
					catharsis.transaction(({ updateEnvironment }) => updateEnvironment({ activeVariant: variantId }))
				}
			} else {
				delete compVariantMap[compId]
			}

			featureState.update(() => ({ compVariantMap }))
		}

		return {
			getActiveVariant: (compId) => featureState.get().compVariantMap[compId],
			getActiveVariants: () => featureState.get().compVariantMap,
			hasActiveVariants: () => !_.isEmpty(featureState.get().compVariantMap),
			setActiveVariant: updateState,
			resetActiveVariants: updateState,
			getCurrentPageActiveVariant: () => currentPageActiveVariant,
			setCurrentPageActiveVariant: (newActiveVariant) => {
				currentPageActiveVariant = newActiveVariant
			},
		}
	}
)
